<!-- Banners -->
<div class="form-banner-list">
  @if (config['EFI_Maintenance_Banner'] || eFileDisabled) {
    <app-banner type="error"
                [header]="'Service Offline'"
                [message]="formDetail.eFileMaintenanceBanner ?? config['EFI_Maintenance_Banner'] ?? 'The Assessor e-File submission system is down for maintenance. Please check back soon. We apologize for any inconvenience caused.'">
    </app-banner>
  }
<!--  <app-banner *ngIf="!formDetail" type="error" [header]="'Form Not Found'" [message]="'The requested form does not exist.'"></app-banner>-->
  <app-banner *ngIf="formDetail && !formDetail.hasEFile && !devMode" type="info" [header]="'Unpublished Form'" [message]="'This form has not been published yet.'"></app-banner>
  <app-banner type="warning" [header]="'Browser Disclaimer'" [message]="'This site is best viewed using the current browser version of Chrome, Microsoft Edge, or Firefox. Please avoid incognito mode.'"></app-banner>
</div>

<!-- Initial loading indicator -->
<div *ngIf="formLoadState === FormLoadState.loading">
  <div class="p-2" style="display: flex; align-items: center; justify-content: center; flex-direction: column">
    <app-loading-spinner></app-loading-spinner>
    <p style="color: black; margin-top: 10px">Loading the form...</p>
  </div>
</div>

<!-- Main Form Info -->
<div *ngIf="formDetail && (formDetail.hasEFile || devMode)" id="formTop">
  <app-progress-bar [progress]="formProgress"></app-progress-bar>

  <div style="display: flex; gap: 5px; padding-top: 5px">
    <!-- Sidebar -->
    <div class="sidebar-container">
      <app-form-outline [outlineItems]="outlineItems" [outlineItemIndex]="outlineItemIndex"></app-form-outline>
    </div>
    <!-- Pages -->
    <div class="form-container">
      <div *ngFor="let formPage of formPages; let i = index; trackBy: trackFormPage">
        <div class="efile-page" [hidden]="pageIndex !== i" [@slideInOutAnimation]="pageIndex === i ? 'in' : (pageIndex > i ? 'outLeft' : 'outRight')">

          <!-- Toolbar -->
          <div style="display: flex; justify-content: space-between">
            <button class="btn btn-primary btn-assessor" (click)="handleReturnToFormsClicked(confirmReturnToForms)"><i class="fas fa-arrow-left"></i> Return to Forms</button>
            <div style="display: flex; gap: 10px">
              <button class="btn btn-primary btn-assessor" (click)="handleEFileInstructionsClicked()"><i class="fa-brands fa-readme"></i> E-File Instructions</button>
              <button class="btn btn-primary btn-assessor" (click)="handlePreviewClicked(pdfPreviewPopUp)"><i class="fa-regular fa-file-pdf"></i> Open Preview</button>
            </div>
          </div>
          <hr/>

          <ng-container *ngIf="i === 0">
            <div *ngIf="userInfo">
              <h2 style="color: #043c5a">Welcome {{ userInfo.lastName }}, {{ userInfo.firstName }} {{ userInfo.middleName }}</h2>
            </div>
            <div *ngIf="!userInfo">
              <h2 style="color: #043c5a">Welcome</h2>
            </div>
            <p style="color: black">You are about to fill-out an online web-form.</p>
            <hr>
          </ng-container>
          <form>
            <h1 style="color: black">{{formPage.title}}</h1>
            <div *ngFor="let control of formPage.controls; let i = index">
              <ng-container [ngSwitch]="control.element.type">
                <div *ngSwitchCase="'template'">
                  <app-form-template-array [formGroup]="formPage.formGroup" [control]="control" [templates]="templates" [controls]="controls" [viewModel]="viewModel"></app-form-template-array>
                </div>
                <div *ngSwitchCase="'form_summary'">
                  <p style="color: black">Please review each form entry for correctness. If you need to make changes, click the "Modify" button to return to that page in the form.</p>
                  <ng-container *ngFor="let formPageSummary of formSummaries; let i = index; trackBy: trackIndex">
                    <app-form-page-summary [pageSummary]="formPageSummary" (modifyButtonClicked)="handleModifyClicked($event)"></app-form-page-summary>
                  </ng-container>
                </div>
                <div *ngSwitchCase="'form_preview'">
                  <p style="color: black">Please review the form preview for correctness. After this point you will not be able to make changes. If you require changes after this point, you will need to start a new submission.</p>
                  <app-pdf-preview [pdfPreviewUrl]="pdfPreviewUrl"></app-pdf-preview>
                </div>
                <div *ngSwitchCase="'form_loading'">
                  <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
                    <app-loading-spinner></app-loading-spinner>
                    <p style="color: black; margin-top: 10px">We're generating the form now</p>
                  </div>
                </div>
                <div *ngSwitchCase="'form_error'">
                  <p style="color: black; margin-top: 10px; margin-bottom: 0">Something went wrong generating the form. Please click resubmit or make corrections and try again.</p>
                  <p style="color: red; margin-top: 0"><b>{{ eFileSubmissionError }}</b></p>
                  <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
                    <div style="display: flex; flex-direction: column; gap: 10px">
                      <button class="btn btn-primary btn-assessor" (click)="handleResubmitClicked()">Resubmit Form</button>
                      <button class="btn btn-primary btn-assessor" (click)="handleConfirmationClicked()">Review Form</button>
                    </div>
                  </div>
                </div>
                <div *ngSwitchCase="'signix_signature'">
                  <p *ngIf="!isSignixFrameLoading" style="color: black">If you are unable to see the signature page below, click to <a id="fallbackSignixUrl" (click)="handleSignixTimeoutLinkClicked()">sign the document</a>. You can also sign the document from the <a href="/efile/status" target="_blank">Online Submission Status Page</a>.</p>
                  <!-- Show alert if mobile -->
                  <alert *ngIf="formHelper.isMobileDevice()" type="info">
                    <p class="m-3">If the pop up is blocked, please click to <a href="{{this.documentResponse?.url}}">sign the document</a></p>
                  </alert>
                  <!-- Otherwise, show the desktop content -->
                  <div *ngIf="!formHelper.isMobileDevice() && !formHelper.isSafari()">
                    <div *ngIf="isSignixFrameLoading" style="display: flex; align-items: center; justify-content: center; flex-direction: column">
                      <app-loading-spinner></app-loading-spinner>
                      <p style="color: black">Generating the signature page</p>
                    </div>
                    <iframe [style.width]="isSignixFrameLoading ? '0%' : '100%'" style="overflow:hidden; height:100vh; border: none" [src]="this.documentResponse?.url | SafeUrl" (load)="onSignixFrameLoad()"></iframe>
                  </div>
                </div>
                <div *ngSwitchDefault>
                  <app-dynamic-control [formGroup]="formPage.formGroup"
                                       [control]="control"
                                       [viewModel]="viewModel"
                                       [controlCache]="controls"></app-dynamic-control>
                </div>
              </ng-container>
            </div>
            <!-- Landing page -->
            <ng-container *ngIf="i === 0">
              <div class="mt-5" style="display: flex; justify-content: flex-end; align-items: center; gap: 10px">
                <button class="btn btn-primary btn-assessor" (click)="handleDownloadFormClicked()">View the Form</button>
                <p style="color: black; margin-bottom: 0">OR</p>
                <button class="btn btn-primary btn-assessor" (click)="handleNextClicked()" [disabled]="eFileDisabled" [ngbTooltip]="eFileDisabledToolTip">Start Online Submission <i class="fas fa-arrow-right"></i></button>
              </div>
            </ng-container>
            <!-- Navigation pages -->
            <ng-container *ngIf="i > 0 && formPage.hasNavButtons">
              <div class="mt-5" style="display: flex; flex-direction: column;">
                <hr />
                <div style="display: flex; flex-direction: column; gap: 10px">
                  <!-- Nav buttons -->
                  <div style="display: flex; align-items: center; justify-content: center; gap: 10px">
                    <button class="btn btn-primary btn-assessor" (click)="handlePreviousClicked()" [disabled]="doesNotHavePrevious()"><i class="fa-solid fa-chevron-left"></i> Previous</button>
                    <p style="margin-bottom: 0; color: black">Page {{ outlineItemIndex + 1 }} of {{ outlineItems.length }}</p>
                    <!-- Conditionally style next button based on the current page -->
                    <ng-container [ngSwitch]="formPage.type">
                      <button *ngSwitchCase="'form_preview'" class="btn btn-primary btn-submit" [disabled]="eFileDisabled" [ngbTooltip]="eFileDisabledToolTip" (click)="handleConfirmSubmissionClicked(finalConfirmationPopUp)">Submit Form <i class="fa-regular fa-paper-plane"></i></button>
                      <button *ngSwitchDefault class="btn btn-primary btn-assessor" (click)="handleNextClicked()" [disabled]="eFileDisabled" [ngbTooltip]="eFileDisabledToolTip">Next <i class="fa-solid fa-chevron-right"></i></button>
                    </ng-container>
                  </div>
                  <!-- Return to form -->
                  <div style="display: flex; align-items: center; justify-content: center;">
                    <button *ngIf="formPage.hasReturnBack" class="btn btn-primary btn-assessor" (click)="handleReturnBack()"><i class="fa-regular fa-rectangle-list"></i> Return to Confirmation</button>
                  </div>
                </div>
              </div>
            </ng-container>
          </form>
          <ng-container *ngIf="pageHasFormHints()" class="mt-5">
            <hr>
            <app-form-faq [formPage]="formPages[pageIndex]"></app-form-faq>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Temporary hack to fix viewport resize -->
<div style="height: 5px" class="mb-5"></div>

<ng-template #genericAlert>
    <div *ngIf="viewModel.modalAlertMessage" style="display: flex; flex-direction: column; padding: 10px; gap: 5px; background: ghostwhite">
        <h1 class="modalHeaderText">{{viewModel.modalAlertMessage.title}}</h1>
        <div style="color: black; text-align: center" [innerHTML]="viewModel.modalAlertMessage.message"></div>
        <button class="btn btn-primary btn-assessor" (click)="modalRef.hide()">Close</button>
    </div>
</ng-template>
<ng-template #confirmReturnToForms>
  <div style="display: flex; flex-direction: column; padding: 10px; gap: 5px; background: ghostwhite">
    <h1 class="modalHeaderText">Return to Forms</h1>
    <p style="color: black">If you click "Confirm Return to Forms" you will lose any unsaved form progress.</p>
    <button class="btn btn-primary btn-danger" routerLink="/forms" (click)="modalRef.hide()">Confirm Return to Forms</button>
    <button class="btn btn-primary btn-assessor" (click)="modalRef.hide()">Stay on e-File</button>
  </div>
</ng-template>
<ng-template #pdfPreviewPopUp>
  <div style="display: flex; flex-direction: column; padding: 10px; gap: 5px; background: ghostwhite">
    <app-pdf-preview [pdfPreviewUrl]="pdfPreviewUrl"></app-pdf-preview>
    <button class="btn btn-primary btn-assessor" (click)="modalRef.hide()">Close Preview</button>
  </div>
</ng-template>
<ng-template #finalConfirmationPopUp>
  <div style="padding: 20px; display: flex; flex-direction: column; gap: 5px; background: ghostwhite">
    <h2 style="color: black; text-align: center">Confirm Submission</h2>
    <p style="color: black">You are about to submit a form. After clicking Submit Form, you will be unable to make
      changes. If you need to make changes after this point, you will need to start a new submission.</p>

    <div style="display: flex; flex-direction: column; align-items: center; gap: 5px">
      <button class="btn btn-primary btn-submit" style="width: 50%" (click)="handleSubmissionConfirmedClicked()">Submit Form</button>
      <button class="btn btn-primary btn-assessor " style="width: 50%" (click)="modalRef.hide()">Return to Form Review</button>
    </div>
  </div>
</ng-template>
